import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { Toaster } from 'sonner';
import TopProgressBar from '@/components/TopProgressBar';
import LoginPage from '@/pages/LoginPage';
import AuthCallback from '@/pages/AuthCallback';
import MobileGoogleLogin from '@/pages/MobileGoogleLogin';
import Dashboard from '@/pages/Dashboard';
import MunicipioDashboard from '@/pages/MunicipioDashboard';
import CompanyDashboard from '@/pages/CompanyDashboard';
import CompanyRoutesPage from '@/pages/CompanyRoutesPage';
import CompanyMemberPage from '@/pages/CompanyMemberPage';
import JoinCompanyPage from '@/pages/JoinCompanyPage';
import PublicMunicipality from '@/pages/PublicMunicipality';
import EmbedMunicipality from '@/pages/EmbedMunicipality';
import LeaderboardProjector from '@/pages/LeaderboardProjector';
import LicenseDevice from '@/pages/LicenseDevice';
import PublicRoute from '@/pages/PublicRoute';
import InviteAccept from '@/pages/InviteAccept';
import AutocolantesPage from '@/pages/AutocolantesPage';
import PublicPassportPage from '@/pages/PublicPassportPage';
import DeleteAccountPage from '@/pages/DeleteAccountPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import '@/App.css';

function AppRouter() {
  const location = useLocation();

  // Bridge para autenticação Google da app móvel — tem prioridade sobre o
  // AuthCallback normal porque REDIRECCIONA para um deep link `tectur4x4://`
  // em vez de navegar para /dashboard.
  if (location.pathname === '/mobile-google-login') {
    return <MobileGoogleLogin />;
  }

  // Check URL fragment for session_id synchronously (fluxo Web)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/municipio" element={<MunicipioDashboard />} />
      <Route path="/municipio/dashboard" element={<MunicipioDashboard />} />
      <Route path="/empresa" element={<CompanyDashboard />} />
      <Route path="/empresa/dashboard" element={<CompanyDashboard />} />
      <Route path="/empresa/rotas" element={<CompanyRoutesPage />} />
      <Route path="/empresa/membro" element={<CompanyMemberPage />} />
      <Route path="/join-company/:token" element={<JoinCompanyPage />} />
      <Route path="/autocolantes" element={<AutocolantesPage />} />
      <Route path="/passport/:userId" element={<PublicPassportPage />} />
      <Route path="/apagar-conta" element={<DeleteAccountPage />} />
      <Route path="/delete-account" element={<DeleteAccountPage />} />
      <Route path="/mobile-google-login" element={<MobileGoogleLogin />} />
      <Route path="/r/:routeId" element={<PublicRoute />} />
      <Route path="/m/:slug" element={<PublicMunicipality />} />
      <Route path="/embed/m/:slug" element={<EmbedMunicipality />} />
      <Route path="/leaderboard/:challengeId" element={<LeaderboardProjector />} />
      <Route path="/license-device/:deviceId" element={<LicenseDevice />} />
      <Route path="/invite/:token" element={<InviteAccept />} />
      {/* Catchall: redirect unknown routes to dashboard (evita ecrã preto). */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TopProgressBar />
        <Toaster position="top-center" richColors />
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
